import React from 'react'
import styled from 'styled-components'
import { FieldErrors, Path, UseFormRegister } from 'react-hook-form'
import { IFormInput } from './types'

export type InputProps = {
  fieldName: Path<IFormInput>
  label: string
  type?: 'text' | 'email' | 'password' | 'url' | 'date' | 'checkbox' | 'hidden'
  register: UseFormRegister<IFormInput>
  readOnly?: boolean
  registerOptions: Object
  disabled?: boolean
  errors?: FieldErrors
  isLoading?: boolean
  hasOldAddress?: boolean
  onChange?: Function
  hidden?: boolean
}

export const FormHeading = styled.h1`
  margin-bottom: 40px;
`
export const FormDescription = styled.p``
export const FormLabel = styled.label``
export const FormInput = styled.input``
export const FormSubmit = styled.input`
  cursor: pointer;
`
export const FormError = styled.p`
  color: #bf1650;
  &:before {
    display: inline;
    content: '⚠ ';
  }
`
